import { SideStatistics } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { CreateSideStatisticsModel } from './C51SideStatistics.service';
import { C51SideStatisticsProps } from './C51SideStatistics.types';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: C51SideStatisticsProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const model = CreateSideStatisticsModel(props);

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering.componentName}>
        <SideStatistics
          className={translationClasses(props?.params)}
          id={props?.params?.AnchorLinkTargetName}
          {...model}
        />
      </SwitchToPreviewMessage>
    );
  }

  return (
    <SideStatistics
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...model}
    />
  );
};

export default checkDatasourceForRendering<C51SideStatisticsProps>(Default);
